import React from "react";
var __jsx = React.createElement;
import Markdown from "markdown-to-jsx";
import { motion } from "framer-motion";
import { Icon } from "@syarahtech/ui";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { bnplItemToPurchaseMethod } from "./utils";
import RadioDot from "./RadioDot";
import InfoIconButton from "./InfoIconButton";
import CornerRibbon from "./CornerRibbon";
export default function BnplItemCard(_ref) {
  var _rejectionItem$title, _ref2, _rejectionItem$ribbon, _item$bank_logos;
  var item = _ref.item,
    selectedSplitPaymentUrl = _ref.selectedSplitPaymentUrl,
    rejectionItem = _ref.rejectionItem,
    onSelect = _ref.onSelect,
    onInfoClick = _ref.onInfoClick;
  var purchaseMethod = useCheckoutOrder().state.purchaseMethod;
  var purchaseMethodValue = bnplItemToPurchaseMethod(item.method_type);
  var disabled = item.state.enabled === false || !!rejectionItem;
  var isSelected = !!purchaseMethodValue && purchaseMethod === purchaseMethodValue && !selectedSplitPaymentUrl;
  var displayTitle = (_rejectionItem$title = rejectionItem === null || rejectionItem === void 0 ? void 0 : rejectionItem.title) !== null && _rejectionItem$title !== void 0 ? _rejectionItem$title : item.title;
  var ribbon = (_ref2 = (_rejectionItem$ribbon = rejectionItem === null || rejectionItem === void 0 ? void 0 : rejectionItem.ribbon) !== null && _rejectionItem$ribbon !== void 0 ? _rejectionItem$ribbon : item.ribbon) !== null && _ref2 !== void 0 ? _ref2 : null;
  var bankLogos = (_item$bank_logos = item.bank_logos) !== null && _item$bank_logos !== void 0 ? _item$bank_logos : [];
  var hasBankLogos = !disabled && bankLogos.length > 0;
  return /*#__PURE__*/React.createElement(motion.button, {
    type: "button",
    disabled: disabled,
    onClick: function onClick() {
      if (!disabled) onSelect();
    },
    whileTap: disabled ? undefined : {
      scale: 0.985
    },
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 25
    },
    className: ["relative overflow-hidden flex w-full gap-[10px] p-4 transition-colors", hasBankLogos ? "items-start" : "items-center", isSelected ? "bg-[#f1f6fc]" : "bg-white", disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-[#f1f6fc]", ribbon && "py-6"].join(" ")
  }, ribbon && /*#__PURE__*/React.createElement(CornerRibbon, {
    ribbon: ribbon
  }), disabled ? /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--lock-outline",
    className: "shrink-0 text-[#b0b0b0]",
    width: 5,
    height: 5
  }) : /*#__PURE__*/React.createElement(RadioDot, {
    selected: isSelected
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 gap-2 ".concat(hasBankLogos ? "items-start md:flex-none md:gap-3" : "items-center")
  }, item.img && /*#__PURE__*/React.createElement("img", {
    src: item.img,
    alt: item.method_type,
    className: "h-5 w-[66px] shrink-0 rounded object-contain ".concat(disabled ? "opacity-[0.32]" : "")
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 gap-1 ".concat(hasBankLogos ? "flex-col items-start md:w-auto md:min-w-[225px] md:max-w-[320px] md:flex-none" : "items-center")
  }, disabled ? /*#__PURE__*/React.createElement("p", {
    className: "w-[150px] shrink-0 text-start text-xs font-semibold leading-4 text-[#b0b0b0]"
  }, displayTitle) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 ".concat(hasBankLogos ? "w-full" : "flex-1")
  }, /*#__PURE__*/React.createElement("p", {
    className: "min-w-0 text-start text-sm font-bold leading-5 [&_strong]:font-bold text-[#00143c] ".concat(hasBankLogos ? "md:whitespace-nowrap" : "")
  }, /*#__PURE__*/React.createElement(Markdown, {
    options: {
      forceInline: true
    }
  }, displayTitle)), item.info && /*#__PURE__*/React.createElement(InfoIconButton, {
    action: item.info.action,
    onOpen: onInfoClick
  })), hasBankLogos && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "h-px w-full bg-[#dadfe9]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex h-[30px] w-full items-center justify-center gap-2.5 md:gap-4 overflow-hidden rounded-[4.286px] bg-[#f2f2f2] px-[6px] py-[4px]"
  }, bankLogos.map(function (logo) {
    return /*#__PURE__*/React.createElement("img", {
      key: logo,
      src: logo,
      alt: "",
      className: "h-[22px] w-auto max-w-[44px] shrink-0 object-contain"
    });
  })))))));
}